import systems from "@/resources/systems-modules-events/systems.json";
import modules from "@/resources/systems-modules-events/modules.json";
import events from "@/resources/systems-modules-events/events.json";

export { systems, modules, events };
// TODO: pq tem dois grupos economicos event? Cobrar tarefa https://app.clickup.com/3006379/v/l/6-193096624-1
